/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-slot-item[_ngcontent-%COMP%]{padding:12px;border-radius:5px;border:1px solid #d3d3d3;margin:0 8px;cursor:pointer}.happ-slot-item.active[_ngcontent-%COMP%], .happ-slot-item[_ngcontent-%COMP%]:hover{background:#d3d3d3}.happ-input-time[_ngcontent-%COMP%]{background:#e0dcdc;padding:10px 10px 10px 18px;text-align:center;border-radius:10px;font-size:18px;margin:4px}"];
export { styles as styles };
